import axios from 'axios';

import {GET_LOCATION_DATA} from '../constants/data'

const baseUrl = 'https://forward-reverse-geocoding.p.rapidapi.com';
const locationHeaders = {
    'X-RapidAPI-Host': 'forward-reverse-geocoding.p.rapidapi.com',
    'X-RapidAPI-Key': process.env.REACT_APP_API_LOC_KEY
  }
  //console.log(process.env.REACT_APP_API_KEY)

  const API = axios.create({baseURL:baseUrl, headers:locationHeaders});
  //const location = 'nayattupara'
  export const getLocationData = (location)=>async(dispatch)=>{
    
      const {data} = await API.get(`/v1/search?q=${location}`);
     
      dispatch({type:GET_LOCATION_DATA,payload:data})
  }
  